<template>
  <v-main>
    <v-container fluid>
      <v-col class="lighten-3 pa-1" cols="12">
        <div class="light-green lighten-3 pt16">
          <div class="white text-center py-6"></div>
        </div>
      </v-col>
      <v-row class="fill-height">
        <v-col>
          <v-sheet height="64">
            <v-toolbar flat color="white">
              <v-btn
                outlined
                class="mr-4"
                color="grey darken-2"
                @click="setToday"
                >Сьогодні</v-btn
              >
              <v-btn fab text small color="grey darken-2" @click="prev">
                <v-icon small id="chevron-left">mdi-chevron-left</v-icon>
              </v-btn>
              <v-btn fab text small color="grey darken-2" @click="next">
                <v-icon small id="chevron-right">mdi-chevron-right</v-icon>
              </v-btn>
              <v-toolbar-title v-if="$refs.calendar">{{
                $refs.calendar.title
              }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-menu bottom right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    outlined
                    color="grey darken-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <span>{{ typeToLabel[type] }}</span>
                    <v-icon right>mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="selectType('day')">
                    <v-list-item-title>День</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="selectType('week')">
                    <v-list-item-title>Тиждень</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="selectType('month')">
                    <v-list-item-title>Mісяць</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="selectType('4day')">
                    <v-list-item-title>4 дні</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-sheet>
          <v-sheet height="600" v-if="ready">
            <v-calendar
              ref="calendar"
              v-model="focus"
              color="primary"
              event-text-color="black"
              :events="events"
              :event-color="getEventColor"
              :type="type"
              :weekdays="weekdays"
              :locale="locale"
              :first-time="firstInterval"
              :start="start"
              @click:event="showEvent"
              @click:more="viewDay"
              @click:date="viewDay"
              @change="updateRange"
            ></v-calendar>
            <v-menu
              v-model="selectedOpen"
              :close-on-content-click="false"
              :activator="selectedElement"
              offset-x
            >
              <v-card color="grey lighten-4" min-width="350px" flat>
                <v-toolbar :color="selectedEvent.color" dark>
                  <v-toolbar-title
                    class="color-title-calendar"
                    v-html="selectedEvent.name"
                  ></v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                  <span v-html="selectedEvent.description"></span>
                </v-card-text>
                <v-card-actions>
                  <v-btn text color="primary" @click="selectedOpen = false"
                    >Закрити</v-btn
                  >
                  <v-btn
                    v-if="selectedEvent.lesson_id"
                    text
                    color="primary"
                    @click="openLesson(selectedEvent)"
                    >Відкрити урок</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
const DEFATLT_TYPE = 'week';
const DEFATLT_START = createDate(new Date());

function createDate(date) {
  return new Date(date).toISOString().slice(0, 10);
}

class CalendarState {
  constructor() {
    this.type = DEFATLT_TYPE;
    this.start = DEFATLT_START;
  }

  init() {
    const serializeData = localStorage.getItem('CalendateState');
    if (serializeData) {
      this.deserialize(serializeData);
    }
  }

  update() {
    const serializeData = this.serialize();
    localStorage.setItem('CalendateState', serializeData);
  }

  setType(type) {
    this.type = type;
    this.update();
  }

  setStart(start) {
    this.start = start;
    this.update();
  }

  getType() {
    return this.type;
  }
  getStart() {
    return this.start;
  }

  serialize() {
    return JSON.stringify({
      type: this.type,
      start: this.start,
    });
  }

  deserialize(serializeData) {
    const data = JSON.parse(serializeData);
    this.type = data.type;
    this.start = data.start;
  }
}

// localStorage.removeItem('rawUser');
const weekdaysDefault = [1, 2, 3, 4, 5, 6, 0];
export default {
  name: 'Calendar',
  data: () => ({
    calendarState: new CalendarState(),
    ready: false,
    focus: DEFATLT_START,
    type: DEFATLT_TYPE,
    start: DEFATLT_START,
    typeToLabel: {
      month: 'Mісяць',
      week: 'Тиждень',
      day: 'День',
      '4day': '4 дні',
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    colors: [
      'blue',
      'indigo',
      'deep-purple',
      'cyan',
      'green',
      'orange',
      'grey darken-1',
    ],
    names: [
      'Meeting',
      'Holiday',
      'PTO',
      'Travel',
      'Event',
      'Birthday',
      'Conference',
      'Party',
    ],
    weekdays: weekdaysDefault,
    locale: 'uk',
    firstInterval: '7',
  }),
  async mounted() {
    this.calendarState.init();
    this.type = this.calendarState.getType();
    this.start = this.calendarState.getStart();
    this.ready = true;
    await this.$nextTick();
    this.$refs.calendar.checkChange();
  },
  methods: {
    selectType(type) {
      this.type = type;
      this.calendarState.setType(type);
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = 'day';
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = DEFATLT_START;
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    openLesson(selectedEvent) {
      this.$router.push({
        name: 'lesson',
        params: { lessonId: selectedEvent.lesson_id },
      });
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    async updateRange({ start, end }) {
      this.calendarState.setStart(start.date);
      const parsedStart = createDate(new Date(start.date));
      const parsedEnd = createDate(new Date(end.date));

      await this.$store.dispatch('CalendarStore/loadCalendar', {
        start: parsedStart,
        end: parsedEnd,
      });
      this.events = this.calendar;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
  },

  computed: {
    calendar() {
      const calendar = this.$store.getters['CalendarStore/getCalendar'];
      return calendar.map((event) => {
        event.end = new Date(event.end);
        event.start = new Date(event.start);
        return event;
      });
    },
  },
};
</script>
